export const selectData = state => state;
export const selectIsFetching = state => state.isFetching;
export const selectItems = state => state.items ?? [];
